import React from 'react';
import cn from 'clsx';
import { ProductCardsList, Section, SectionSubTitle, Typography } from 'common/components';
import { createElementKey } from 'utils';
import {
  FENCES_SUBTYPES_SECTION_TITLE_MAP,
  FENCES_TYPES_CHARASTERISTICS_LIST_MAP,
  FENCES_TYPES_SUBTYPES_LIST_MAP,
} from './fences-subtypes-section-constants';
import { FencesSubTypeStructure, FencesTypePropertyStructure } from './fences-subtypes-section-types';
import {
  fencesModulnyeSubtypesItemProperty,
  fencesPanelnyeSubtypesItemProperty,
  fencesProfnastilSubtypesItem,
  fencesProfnastilSubtypesSection,
  fencesSubtypesCharacteristicName,
  fencesSubtypesCharacteristicsStylesMap,
  fencesSubtypesCharacteristicsWrapper,
  fencesSubtypesItem,
  fencesSubtypesItemProperty,
  fencesSubtypesItemText,
  fencesSubtypesSection,
  fencesSubtypesSectionImage,
  fencesSubtypesSectionTitle,
} from './fences-subtypes-section-styles';

type FencesSubtypesSectionProps = {
  elementBlock: string;
  fencesType: string;
};

export const FencesSubtypesSection: React.FC<FencesSubtypesSectionProps> = ({
  elementBlock,
  fencesType,
}) => {
  const sectionTitle = FENCES_SUBTYPES_SECTION_TITLE_MAP[fencesType];
  const typeCharacteristics = FENCES_TYPES_CHARASTERISTICS_LIST_MAP[fencesType];
  const subTypesList = FENCES_TYPES_SUBTYPES_LIST_MAP[fencesType]; // name, alt, imgSrc, properties{name, value}, text

  return (
    <Section
      className={cn(fencesSubtypesSection, {
        [fencesProfnastilSubtypesSection]: fencesType === 'zabory-iz-profnastila',
      })}>
      <SectionSubTitle margin="m" className={fencesSubtypesSectionTitle}>
        {sectionTitle}
      </SectionSubTitle>
      {typeCharacteristics && (
        <div
          className={cn(
            fencesSubtypesCharacteristicsWrapper,
            fencesSubtypesCharacteristicsStylesMap[typeCharacteristics.length]
          )}>
          {typeCharacteristics.map(({ name, value }: FencesTypePropertyStructure, index: number) => (
            <div key={createElementKey('characteristic', index)}>
              <Typography
                adaptive={false}
                className={fencesSubtypesCharacteristicName}
                variant="m"
                size="body_long"
                color="text-secondary">
                {name}
              </Typography>
              <Typography adaptive={false} variant="m" size="body_long">
                {value}
              </Typography>
            </div>
          ))}
        </div>
      )}
      <ProductCardsList
        swiperSlideClassName={cn(fencesSubtypesItem, {
          [fencesProfnastilSubtypesItem]: fencesType === 'zabory-iz-profnastila',
        })}
        elementBlock={elementBlock}
        productList={subTypesList}
        renderProductCard={({ name, alt, imgSrc, properties, text }: FencesSubTypeStructure) => (
          <>
            <img
              className={fencesSubtypesSectionImage}
              alt={alt}
              src={imgSrc}
              title={name}
              width="144"
              height="144"
            />
            <Typography adaptive={false} size="subtitle" variant="m">
              {name}
            </Typography>
            {properties &&
              properties.map((property, index) => (
                <div
                  className={cn(
                    fencesSubtypesItemProperty,
                    { [fencesPanelnyeSubtypesItemProperty]: fencesType === 'panelnye-ograzhdeniya' },
                    { [fencesModulnyeSubtypesItemProperty]: fencesType === 'modulnye-ograzhdeniya' }
                  )}
                  key={createElementKey('property', index)}>
                  <Typography variant="s" size="body_long" color="text-secondary">
                    {property.name}
                  </Typography>
                  <Typography variant="s" size="body_long">
                    {property.value}
                  </Typography>
                </div>
              ))}
            {text && (
              <Typography className={fencesSubtypesItemText} adaptive={false} variant="s" size="body_long">
                {text}
              </Typography>
            )}
          </>
        )}
        sectionTitle={sectionTitle}
      />
    </Section>
  );
};
